import { createReducer, on } from "@ngrx/store"
import { INotasFiscaisReport } from "src/app/shared/interfaces/notasFiscaisReport/inotasfiscaisreport"
import { notasFiscaisReportActions } from "./notas-fiscais-report.actions"

export interface INotasFiscaisReportState {
    notas_fiscais_report: INotasFiscaisReport
}

const initialState: INotasFiscaisReportState = {
    notas_fiscais_report: {
        economia_mes_a_mes: [
            {
              label: "03/23",
              data: 14000
            },
            {
              label: "04/23",
              data: 9000
            },
            {
              label: "05/23",
              data: 10000
            },
            {
              label: "06/23",
              data: 6000
            },
            {
              label: "07/23",
              data: 8000
            },
            {
              label: "08/23",
              data: 12000
            },
            {
              label: "09/23",
              data: 12500
            },
            {
              label: "10/23",
              data: 12000
            },
            {
              label: "11/23",
              data: 14000
            },
            {
              label: "12/23",
              data: 13000
            },
            {
              label: "01/24",
              data: 15000
            },
            {
              label: "02/24",
              data: 12185.12
            }
          ],
        notas_fiscais_empresa: {
            nome_unidade: "Instituto X",
            qtd_atendimentos: "30",
            NF_automatica: true,
            qtd_NF_emitidas: "748",
            qtd_NF_contabilidade: "0",
            qte_erro: "2",
            valor_notas: "150.000",
            comparativo_notas_mes_anterios_porcentagem: "-30"
        },
        notas_fiscais_profissional: [
            {
                nome_profissional: "Carlos Henrique",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Amanda Gomes",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Antônio Carlos",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Gabriel Santos",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Carlos Henrique",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Amanda Gomes",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Antônio Carlos",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            },
            {
                nome_profissional: "Gabriel Santos",
                qtd_atendimentos: "30",
                NF_automatica: true,
                qtd_NF_emitidas: "748",
                qtd_NF_contabilidade: "0",
                qtd_erro: "0",
                valor_notas: "150.000",
                valor_economia_IR: "5.000",
                comparativo_notas_mes_anterior_porcentagem: "-30",
                notas: [
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "150",
                        valor_especialista: "100"
                    },
                    {
                        data_emissao: "14/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "150",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "13/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "150",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Carlos Antônio",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "250",
                        valor_centro: "250",
                        valor_especialista: "250"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Maria de Fátima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "410",
                        valor_centro: "410",
                        valor_especialista: "410"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Gabriel Lima",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "310",
                        valor_centro: "310",
                        valor_especialista: "310"
                    },
                    {
                        data_emissao: "12/12/2023",
                        nome_paciente: "Leonardo Patrício",
                        nome_servico: "Consulta de Neuropediatria",
                        convenio: "Particular",
                        valor_total_servico: "350",
                        valor_centro: "350",
                        valor_especialista: "350"
                    },
                ]
            }
        ],
        total_notas_ficais_profissionais: {
            total_qtd_atendimentos: "30",
            total_qtd_NF_emitidas: "748",
            total_qtd_NF_contabilidade: "0",
            total_qte_erro: "2",
            total_valor_notas: "150.000",
            total_valor_economia_IR: "5.000",
            total_comparativo_notas_mes_anterios_porcentagem: '-30'
        },
    }
}

export const notasFiscaisReportReducer = createReducer(
    initialState,
    on(
        notasFiscaisReportActions.loadNotasFiscaisReportSuccess,
        (state, { notas_fiscais_report }) => ({
            ...state,
            notas_fiscais_report: notas_fiscais_report
        })
    )
)